import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const logoAnimation = () => {
	const heroModule = document.querySelector('.hero.module__1');

	if (heroModule) {
		const logo = heroModule.querySelector('.js-hero-logo');

		if (logo) {
			const header = document.querySelector('.header');
			const headerLogo = header.querySelector('.header__main-logo');
			const headerLogoWidth = headerLogo.offsetWidth;
			const headerLogoRect = headerLogo.getBoundingClientRect();
			const headerLogoLeft = headerLogoRect.left;
			const headerLogoTop = headerLogoRect.top;

			let mm = gsap.matchMedia();
			mm.add('(prefers-reduced-motion: no-preference) and (min-width: 1200px)', context => {
				let tl = gsap.timeline({
					scrollTrigger: {
						trigger: heroModule,
						start: 'top+=100 top',
						end: 'bottom+=1 40%',
						scrub: true,
						markers: false,
					},
					onUpdate: () => {
						if (tl.progress() === 1) {
							header.classList.add('header--scrolled');
						} else {
							header.classList.remove('header--scrolled');
						}
					},
				});

				tl.to(logo, {
					width: () => headerLogoWidth,
					left: () => headerLogoLeft,
					top: () => headerLogoTop,
				});

				if (logo.querySelector('.logo-full__top-text') && logo.querySelector('.logo-full__bottom-text')) {
					tl.to(
						[logo.querySelector('.logo-full__top-text'), logo.querySelector('.logo-full__bottom-text')],
						{
							opacity: 0,
						},
						'<'
					);
				}

				if (logo.querySelector('.strap')) {
					tl.to(logo.querySelector('.strap'), {
						opacity: 0,
					}, '<');
				}
			});
		}
	}
};

logoAnimation();
